import { ConfigProvider } from 'antd';
import { type PropsWithChildren, useEffect } from 'react';

import { createAntdTheme } from '../lib/antdTheme';
import { applyTheme } from '../lib/applyTheme';
import { themeTokens } from '../lib/tokens';
import { useThemeStore } from '../model/store';

export function ThemeProvider({ children }: PropsWithChildren) {
  const theme = useThemeStore(s => s.theme);

  // Apply CSS variables on mount and theme change
  useEffect(() => {
    applyTheme(themeTokens[theme]);
  }, [theme]);

  return <ConfigProvider theme={createAntdTheme(theme)}>{children}</ConfigProvider>;
}
